








































import { Vue, Component, Prop } from "vue-property-decorator";
import { AdditionInfo, Grade, Gender } from '@/common/interface';
import { GRADE, GENDER } from '@/common/constants';

@Component
export default class AdditionalDetail extends Vue {
  @Prop({ required: true }) additionalInfo!: string;

  grade:string = "";
  gender:string = "";

  get getterAdditionalInfo() {
    return JSON.parse(this.additionalInfo || '{}');
  }
  changeGradeArr(value: number){
    if(!value) return null;
    let grade = GRADE.find((item: Grade) =>{
      return item.value == value;
    })
    return grade ? grade.label : undefined;
  }

  changeGenderArr(value: number){
    if(!value) return null;
    let gender = GENDER.find((item: Gender) =>{
      return item.value == value
    })
    return gender ? gender.label : undefined;
  }

}
